(function ($, Drupal, drupalSettings) {
  "use strict";

  /* 
  | ============================================================================
  | HEADER - Navigation System
  | Migrated from React Navigation component (music-school-reimagined)
  | ============================================================================
  */

  /**
   * Adds a close button to the message.
   *
   * @param {object} message
   *   The message object.
   */
  const closeMessage = (message) => {
    const messageContainer = message.querySelector(".messages");
    const theKid = document.createElement("a");
    theKid.setAttribute("href", "#");
    theKid.classList.add("messageclose");
    theKid.setAttribute("title", "Close");
    theKid.innerHTML = "&times;";
    message.insertBefore(theKid, message.firstChild);

    theKid.addEventListener("click", (e) => {
      e.preventDefault();
      fadeOutEffect(message);
    });
  };

  /* 
  | ----------------------------
  | Language Switcher Dropdown
  | Matches React LanguageSwitcher.tsx behavior
  | ----------------------------
  */
  (function initLanguageSwitcher() {
    var $globe = $(".globe");
    var $languageSwitcher = $(".language-switcher-language-url");

    if (!$globe.length) return;

    // Toggle dropdown on click
    $globe.on("click", function (e) {
      e.stopPropagation();
      var $switcher = $(this).find(".language-switcher-language-url");
      var isOpen = $switcher.hasClass("language-show");

      // Close all other dropdowns first
      $(".language-switcher-language-url").removeClass("language-show");
      $(".globe").removeClass("globe-show");

      // Toggle this dropdown
      if (!isOpen) {
        $switcher.addClass("language-show");
        $(this).addClass("globe-show");
      }
    });

    // Close dropdown when clicking outside
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".globe").length) {
        $(".language-switcher-language-url").removeClass("language-show");
        $(".globe").removeClass("globe-show");
      }
    });

    // Close dropdown on escape key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape") {
        $(".language-switcher-language-url").removeClass("language-show");
        $(".globe").removeClass("globe-show");
      }
    });

    // Close dropdown after selecting a language
    $languageSwitcher.find("a").on("click", function () {
      $(".language-switcher-language-url").removeClass("language-show");
      $(".globe").removeClass("globe-show");
    });
  })();

  // Header scroll detection - adds shadow and solid background on scroll
  Drupal.behaviors.headerScroll = {
    attach: function (context, settings) {
      var header = document.getElementById("main-header");
      if (!header) {
        // Fallback for legacy header element
        header = document.querySelector("header");
      }

      if (header && !header.hasAttribute("data-scroll-attached")) {
        header.setAttribute("data-scroll-attached", "true");

        var scrollThreshold = 20;

        function handleScroll() {
          if (window.scrollY > scrollThreshold) {
            header.classList.add("is-scrolled");
          } else {
            header.classList.remove("is-scrolled");
          }
        }

        // Run once on load
        handleScroll();

        // Listen for scroll
        window.addEventListener("scroll", handleScroll, { passive: true });
      }
    },
  };

  // Mobile menu toggle - Matches React Navigation.tsx behavior
  Drupal.behaviors.mobileMenu = {
    attach: function (context, settings) {
      var burgerToggle = document.getElementById("burger-toggle");
      var mobileClose = document.getElementById("mobile-close");
      var mobileMenu = document.getElementById("mobile-menu");
      var mobileNav = document.querySelector(".header__mobile-nav");
      var header = document.getElementById("main-header");

      // Skip if already attached
      if (burgerToggle && burgerToggle.hasAttribute("data-menu-attached")) {
        return;
      }

      // Store scroll position when opening menu
      var scrollPosition = 0;

      function openMenu() {
        scrollPosition = window.pageYOffset;
        // Add class to multiple elements for CSS targeting
        document.body.classList.add("menu-open");
        if (mobileMenu) {
          mobileMenu.classList.add("is-open");
        }
        if (burgerToggle) {
          burgerToggle.classList.add("is-open");
          burgerToggle.setAttribute("aria-expanded", "true");
        }
        if (header) {
          header.classList.add("menu-open");
        }
        document.body.style.top = -scrollPosition + "px";
        if (mobileMenu) {
          mobileMenu.setAttribute("aria-hidden", "false");
        }
      }

      function closeMenu() {
        document.body.classList.remove("menu-open");
        if (mobileMenu) {
          mobileMenu.classList.remove("is-open");
        }
        if (burgerToggle) {
          burgerToggle.classList.remove("is-open");
          burgerToggle.setAttribute("aria-expanded", "false");
        }
        if (header) {
          header.classList.remove("menu-open");
        }
        document.body.style.top = "";
        window.scrollTo(0, scrollPosition);
        if (mobileMenu) {
          mobileMenu.setAttribute("aria-hidden", "true");
        }
      }

      function isMenuOpen() {
        return (
          document.body.classList.contains("menu-open") ||
          (mobileMenu && mobileMenu.classList.contains("is-open"))
        );
      }

      // Burger toggle click
      if (burgerToggle) {
        burgerToggle.setAttribute("data-menu-attached", "true");

        burgerToggle.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isMenuOpen()) {
            closeMenu();
          } else {
            openMenu();
          }
        });
      }

      // Close button click
      if (mobileClose) {
        mobileClose.setAttribute("data-close-attached", "true");

        mobileClose.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeMenu();
        });
      }

      // Close menu on escape key
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && isMenuOpen()) {
          closeMenu();
          if (burgerToggle) {
            burgerToggle.focus();
          }
        }
      });

      // Close menu when clicking a link (for page navigation)
      if (mobileMenu) {
        mobileMenu.setAttribute("data-links-attached", "true");

        mobileMenu.querySelectorAll("a").forEach(function (link) {
          link.addEventListener("click", function () {
            // Small delay to allow navigation to start
            setTimeout(function () {
              closeMenu();
            }, 100);
          });
        });
      }

      // Mobile submenu toggle (for expandable menu items)
      if (mobileNav) {
        mobileNav.setAttribute("data-submenu-attached", "true");

        var expandedItems = mobileNav.querySelectorAll(
          ".menu-item--expanded > span",
        );
        expandedItems.forEach(function (span) {
          span.addEventListener("click", function (e) {
            e.preventDefault();
            var menuItem = span.parentElement;
            menuItem.classList.toggle("is-expanded");
          });
        });
      }

      // Close menu on window resize to desktop size
      var resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (
            window.innerWidth > 1024 &&
            document.body.classList.contains("menu-open")
          ) {
            closeMenu();
          }
        }, 250);
      });
    },
  };

  // Main content padding for fixed header
  Drupal.behaviors.headerOffset = {
    attach: function (context, settings) {
      var header =
        document.getElementById("main-header") ||
        document.querySelector("header");
      var main = document.querySelector("main");

      if (header && main && !main.hasAttribute("data-offset-attached")) {
        main.setAttribute("data-offset-attached", "true");

        function setMainPadding() {
          var headerHeight = header.offsetHeight;
          main.style.paddingTop = headerHeight + "px";
        }

        setMainPadding();
        window.addEventListener("resize", setMainPadding);
      }
    },
  };

  // Legacy burger support (for old template)
  $(".burger").on("click", function () {
    $("body").toggleClass("open-menu");
    $(".rkpt-search-form").removeClass("active");
    $(".account").removeClass("active");
  });

  // Legacy mobile navigation support
  if ($(window).width() <= 1024) {
    $(".main-navigation>.menu>.menu-item--expanded>span").on(
      "click",
      function () {
        $(this).siblings(".menu").toggleClass("active");
      },
    );
    $(".user-toggle").on("click", function () {
      $(this).parent().toggleClass("active");
      $("body").removeClass("open-menu");
      $(".rkpt-search-form").removeClass("active");
    });
  }

  /* 
  | ----------------------------
  | Search form  
  | ----------------------------
  */
  $(".search-toggle").on("click", function () {
    $(".block-rkpt-search-form-block").toggleClass("active");
    $("body").removeClass("open-menu");
    $(".account").removeClass("active");
  });

  /* 
  | ----------------------------
  | Swiper setup
  | ----------------------------
  */

  function setupSwiper(width, element, options) {
    // breakpoint where swiper will be destroyed
    var breakpoint = window.matchMedia("(min-width:" + width + ")");

    // keep track of swiper instances to destroy later
    var mySwiper;

    var breakpointChecker = function () {
      // if larger viewport and multi-row layout needed
      if (breakpoint.matches) {
        // clean up old instances and inline styles when available
        if (mySwiper !== undefined) {
          mySwiper.destroy(true, true);
          // or/and do nothing
          return;
        }

        // else if a small viewport and double column layout needed
      } else {
        // fire small viewport version of swiper
        return enableSwiper();
      }
    };

    var enableSwiper = function () {
      mySwiper = new Swiper(element, options);
    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }

  //Accordion - Legacy support
  if ($(".accordion").length) {
    // Old structure: .field__label click
    $(".accordion__item .field__label").on("click", function () {
      $(this).parents(".accordion__item").toggleClass("show");
    });

    // New structure: .accordion__trigger click
    $(".accordion__trigger").on("click", function () {
      var $item = $(this).closest(".accordion__item");
      var isOpen = $item.attr("data-state") === "open";

      // Toggle state
      $item.attr("data-state", isOpen ? "closed" : "open");
      $(this).attr("aria-expanded", !isOpen);
      $item.find(".accordion__content").attr("aria-hidden", isOpen);

      // Also toggle .show class for CSS compatibility
      $item.toggleClass("show");
    });
  }

  //Tabs
  if ($(".tabs").length) {
    $(".tabs__item .field__label").on("click", function () {
      if ($(window).width() > 1024) {
        $(".tabs__item").removeClass("active");
        $(this).parents(".tabs__item").addClass("active");
      } else {
        $(this).parents(".tabs__item").toggleClass("active");
      }
    });
  }

  /* 
  | ============================================================================
  | TABS PROGRAMS - Professional Program Jazz/Pop tabs
  | Matches React ProfessionalProgramDetail.tsx segmented control
  | ============================================================================
  */
  Drupal.behaviors.tabsPrograms = {
    attach: function (context, settings) {
      var $tabsContainer = $(".tabs-programs", context);
      if (!$tabsContainer.length) return;

      // Check if already initialized
      if ($tabsContainer.hasClass("tabs-initialized")) return;
      $tabsContainer.addClass("tabs-initialized");

      var $tabButtons = $tabsContainer.find(".tab-button");
      var $tabsContent = $tabsContainer.find(".tabs-content");

      // Find panels - they have data-tab-content attribute
      var $tabPanels = $tabsContent.find("[data-tab-content]");

      // If no panels found, try alternative selectors
      if (!$tabPanels.length) {
        $tabPanels = $tabsContainer.find(".program-tab-panel");
      }

      // Ensure tabs content wrapper is visible
      $tabsContent.css({
        display: "block",
        visibility: "visible",
      });

      // Remove any hidden classes that Drupal might add
      $tabsContent.find(".field-hidden").removeClass("field-hidden");
      $tabsContent.find('[style*="display: none"]').css("display", "");

      // Activate first tab by default
      if (!$tabButtons.filter(".active").length) {
        $tabButtons.first().addClass("active");
      }

      // Get the active tab key
      var activeTab = $tabButtons.filter(".active").data("tab");

      // Initialize panel states with proper visibility
      $tabPanels.each(function () {
        var $panel = $(this);
        var panelKey = $panel.attr("data-tab-content");

        // Force display and visibility reset on all panels first
        $panel.css({
          visibility: "visible",
        });

        if (panelKey === activeTab) {
          $panel
            .addClass("active")
            .removeClass("hidden")
            .attr("aria-hidden", "false")
            .css({
              display: "block",
              opacity: 1,
              transform: "translateY(0)",
              pointerEvents: "auto",
            });
        } else {
          $panel
            .removeClass("active")
            .addClass("hidden")
            .attr("aria-hidden", "true")
            .css({
              display: "none",
              opacity: 0,
              transform: "translateY(20px)",
              pointerEvents: "none",
            });
        }
      });

      // Tab click handler
      $tabButtons.on("click", function (e) {
        e.preventDefault();
        var $btn = $(this);
        var tabKey = $btn.data("tab");

        // Skip if already active
        if ($btn.hasClass("active")) return;

        // Update button states
        $tabButtons.removeClass("active").attr("aria-selected", "false");
        $btn.addClass("active").attr("aria-selected", "true");

        // Find current and target panels
        var $currentPanel = $tabPanels.filter(".active");
        var $targetPanel = $tabPanels.filter(
          '[data-tab-content="' + tabKey + '"]',
        );

        // Skip if target not found
        if (!$targetPanel.length) return;

        // Animate out current panel
        $currentPanel.css({
          opacity: 0,
          transform: "translateY(20px)",
          pointerEvents: "none",
        });

        // After animation completes, switch panels
        setTimeout(function () {
          // Hide current panel completely
          $currentPanel
            .removeClass("active")
            .addClass("hidden")
            .attr("aria-hidden", "true")
            .css({
              display: "none",
            });

          // Show and animate in target panel
          $targetPanel
            .removeClass("hidden")
            .addClass("active")
            .attr("aria-hidden", "false")
            .css({
              display: "block",
              visibility: "visible",
              pointerEvents: "auto",
            });

          // Trigger reflow for animation
          $targetPanel[0].offsetHeight;

          // Animate in
          requestAnimationFrame(function () {
            $targetPanel.css({
              opacity: 1,
              transform: "translateY(0)",
            });
          });

          // Scroll to tabs content smoothly
          var tabsTop = $tabsContent.offset().top - 100;
          if ($(window).scrollTop() > tabsTop) {
            $("html, body").animate({ scrollTop: tabsTop }, 300);
          }

          // Sync direction dropdown with active tab
          syncDirectionDropdown(tabKey);
        }, 250);
      });

      // Function to sync direction dropdown with tab selection
      function syncDirectionDropdown(tabKey) {
        var $directionSelect = $("#edit-direction");
        if ($directionSelect.length) {
          var directionValue = "";
          if (tabKey === "JAZZ" || tabKey === "jazz") {
            directionValue = "Jazz Program";
          } else if (tabKey === "POP" || tabKey === "pop") {
            directionValue = "Pop Program";
          }
          if (directionValue) {
            $directionSelect.val(directionValue).trigger("change");
          }
        }
      }

      // Set initial direction based on active tab
      var initialTab = $tabButtons.filter(".active").data("tab");
      if (initialTab) {
        syncDirectionDropdown(initialTab);
      }
    },
  };

  /* 
  | ============================================================================
  | PROFESSIONAL PROGRAM FORM - Direction Sync
  | Syncs the direction dropdown with the active Jazz/Pop tab
  | ============================================================================
  */
  Drupal.behaviors.professionalProgramFormSync = {
    attach: function (context, settings) {
      var $directionSelect = $("#edit-direction", context);
      if (!$directionSelect.length) return;

      // Check if already initialized
      if ($directionSelect.hasClass("direction-synced")) return;
      $directionSelect.addClass("direction-synced");

      // Function to get active tab key
      function getActiveTabKey() {
        var $activeTab = $(".tab-button.active");
        if ($activeTab.length) {
          return $activeTab.data("tab");
        }
        return "JAZZ"; // Default to Jazz
      }

      // Function to sync dropdown
      function syncDropdown() {
        var tabKey = getActiveTabKey();
        var directionValue = "";
        if (tabKey === "JAZZ" || tabKey === "jazz") {
          directionValue = "Jazz Program";
        } else if (tabKey === "POP" || tabKey === "pop") {
          directionValue = "Pop Program";
        }
        if (directionValue && $directionSelect.val() !== directionValue) {
          $directionSelect.val(directionValue).trigger("change");
        }
      }

      // Sync on initial load
      syncDropdown();

      // Also sync when tabs change
      $(document).on("click", ".tab-button", function () {
        setTimeout(syncDropdown, 300);
      });
    },
  };

  /* 
  | ============================================================================
  | PROFESSIONAL PROGRAM SUBMENU
  | Handles navigation with duplicate IDs across Jazz/Pop tabs
  | Matches React SecondaryNav component behavior
  | ============================================================================
  */
  Drupal.behaviors.professionalProgramSubmenu = {
    attach: function (context, settings) {
      var $submenu = $(".menu-professional-program-submenu", context);
      if (!$submenu.length) return;

      // Check if already initialized
      if ($submenu.hasClass("submenu-initialized")) return;
      $submenu.addClass("submenu-initialized");

      var $menuLinks = $submenu.find("a[href^='#']");
      var headerOffset = 160; // Header (80px) + Submenu (~80px)

      // Get the currently active tab panel
      function getActiveTabPanel() {
        var $activePanel = $(".program-tab-panel.active");
        if ($activePanel.length) {
          return $activePanel;
        }
        // Fallback to first visible panel
        return $(".program-tab-panel:visible").first();
      }

      // Click handler for submenu links
      $menuLinks.on("click", function (e) {
        e.preventDefault();
        var targetId = $(this).attr("href").substring(1); // Remove #
        var $activePanel = getActiveTabPanel();

        // Find the target element within the active panel first
        var $targetElement = $activePanel.find("#" + targetId);

        // If not found in active panel, try document-level (for video section outside tabs)
        if (!$targetElement.length) {
          $targetElement = $("#" + targetId).not(
            ".program-tab-panel #" + targetId,
          );
        }

        // Still not found, fallback to any matching ID
        if (!$targetElement.length) {
          $targetElement = $("#" + targetId).first();
        }

        if ($targetElement.length) {
          var elementPosition = $targetElement.offset().top - headerOffset;
          $("html, body").animate(
            { scrollTop: elementPosition },
            { duration: 500, easing: "swing" },
          );

          // Update active state on menu items
          $menuLinks.removeClass("is-active");
          $(this).addClass("is-active");
        }
      });

      // Scroll spy - update active menu item based on scroll position
      var scrollTimeout;
      $(window).on("scroll", function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var scrollPosition = $(window).scrollTop() + headerOffset + 50;
          var $activePanel = getActiveTabPanel();

          $menuLinks.each(function () {
            var $link = $(this);
            var targetId = $link.attr("href").substring(1);

            // Find target in active panel or document
            var $targetElement = $activePanel.find("#" + targetId);
            if (!$targetElement.length) {
              $targetElement = $("#" + targetId).not(
                ".program-tab-panel #" + targetId,
              );
            }
            if (!$targetElement.length) {
              $targetElement = $("#" + targetId).first();
            }

            if ($targetElement.length) {
              var elementTop = $targetElement.offset().top;
              var elementBottom = elementTop + $targetElement.outerHeight();

              if (
                scrollPosition >= elementTop &&
                scrollPosition < elementBottom
              ) {
                $menuLinks.removeClass("is-active");
                $link.addClass("is-active");
              }
            }
          });
        }, 100);
      });

      // Update submenu when tab changes
      $(document).on("click", ".tab-button", function () {
        // Small delay to let the tab switch complete
        setTimeout(function () {
          // Remove all active states and let scroll spy handle it
          $menuLinks.removeClass("is-active");
          // Trigger scroll to update active state
          $(window).trigger("scroll");
        }, 300);
      });
    },
  };

  /* 
  | ============================================================================
  | STATS COUNTER - Animated number counting
  | Migrated from React StatsSection.tsx (music-school-reimagined)
  | ============================================================================
  */
  Drupal.behaviors.statsCounter = {
    attach: function (context, settings) {
      // Find all stat cards
      var statCards = context.querySelectorAll
        ? context.querySelectorAll(".stat-card, .paragraph--type--single-stat")
        : document.querySelectorAll(
            ".stat-card, .paragraph--type--single-stat",
          );

      statCards.forEach(function (card) {
        if (card.hasAttribute("data-counter-attached")) return;
        card.setAttribute("data-counter-attached", "true");

        var valueElement = card.querySelector(
          ".stat-card__value, .field-field-title",
        );
        if (!valueElement) return;

        var textContent = valueElement.textContent.trim();

        // Parse the number and any suffix (like +, χρόνια, etc.)
        var match = textContent.match(/^([\d,\.]+)(.*)$/);
        if (!match) return;

        var targetNumber = parseInt(match[1].replace(/[,\.]/g, ""), 10);
        var suffix = match[2] || "";

        // Store original for reset
        var originalText = textContent;

        // Set initial value to 0
        valueElement.textContent = "0" + suffix;

        // Create intersection observer for scroll trigger
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                // Start counting animation
                animateCounter(valueElement, targetNumber, suffix, 2000);
                // Only animate once
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.3,
            rootMargin: "0px",
          },
        );

        observer.observe(card);
      });

      // Counter animation function with easing
      function animateCounter(element, target, suffix, duration) {
        var start = 0;
        var startTime = null;

        // Easing function (easeOutQuad)
        function easeOutQuad(t) {
          return t * (2 - t);
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var easedProgress = easeOutQuad(progress);
          var current = Math.floor(easedProgress * target);

          element.textContent = current + suffix;

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            // Ensure final value is exact
            element.textContent = target + suffix;
          }
        }

        requestAnimationFrame(step);
      }
    },
  };

  /* 
  | ============================================================================
  | KINETIC HERO - Instruments Page Animated Typography
  | Matches React InstrumentsKineticHero component (music-school-reimagined)
  | ============================================================================
  */

  Drupal.behaviors.kineticHero = {
    attach: function (context, settings) {
      var hero = document.querySelector(".kinetic-hero");

      if (hero && !hero.hasAttribute("data-kinetic-attached")) {
        hero.setAttribute("data-kinetic-attached", "true");

        var rows = hero.querySelectorAll(".kinetic-hero__row");

        // Enhanced animation using requestAnimationFrame for smoother movement
        // This supplements the CSS animation with scroll-linked parallax
        var lastScrollY = window.scrollY;
        var ticking = false;

        function updateParallax() {
          var scrollY = window.scrollY;
          var heroRect = hero.getBoundingClientRect();

          // Only apply effect when hero is in view
          if (heroRect.top < window.innerHeight && heroRect.bottom > 0) {
            var scrollDelta = (scrollY - lastScrollY) * 0.1;

            rows.forEach(function (row, index) {
              var direction = row.classList.contains("kinetic-hero__row--right")
                ? 1
                : -1;
              var currentTransform = row.style.transform || "";
              var match = currentTransform.match(/translateX\(([^)]+)\)/);
              var currentX = match ? parseFloat(match[1]) : 0;

              // Add subtle scroll-linked movement
              var newX =
                currentX +
                scrollDelta * direction * (index % 2 === 0 ? 0.5 : 0.3);

              // Keep within reasonable bounds
              newX = Math.max(-100, Math.min(100, newX));

              row.style.transform = "translateX(" + newX + "%)";
            });
          }

          lastScrollY = scrollY;
          ticking = false;
        }

        function onScroll() {
          if (!ticking) {
            requestAnimationFrame(updateParallax);
            ticking = true;
          }
        }

        // Optional: Enable scroll-linked parallax (can be performance intensive)
        // Uncomment to enable:
        // window.addEventListener('scroll', onScroll, { passive: true });

        // Ensure videos in instrument cards autoplay
        var videos = document.querySelectorAll(".instrument-card__video");
        videos.forEach(function (video) {
          // Force autoplay on iOS/Safari
          video.play().catch(function (error) {
            // Autoplay was prevented, try again on user interaction
            document.addEventListener(
              "touchstart",
              function () {
                video.play();
              },
              { once: true },
            );
          });
        });
      }
    },
  };

  /* 
  | ============================================================================
  | GSAP SCROLL ANIMATIONS - Instrument Full Page
  | Matches Lovable React design scroll animations
  | ============================================================================
  */

  Drupal.behaviors.gsapScrollAnimations = {
    attach: function (context, settings) {
      // Check if GSAP is loaded
      if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
        console.warn("GSAP or ScrollTrigger not loaded");
        return;
      }

      // Only run once
      var instrumentPage = document.querySelector(".instrument-full-page");
      if (
        !instrumentPage ||
        instrumentPage.hasAttribute("data-gsap-attached")
      ) {
        return;
      }
      instrumentPage.setAttribute("data-gsap-attached", "true");

      // Register ScrollTrigger plugin
      gsap.registerPlugin(ScrollTrigger);

      // Get the instrument color for dynamic theming
      var instrumentColor =
        getComputedStyle(instrumentPage).getPropertyValue(
          "--instrument-color",
        ) || "#EF4444";

      // =========================================================================
      // Kinetic Hero Animations
      // =========================================================================

      var instrumentHero = document.querySelector(".instrument-hero");
      if (instrumentHero) {
        // Entrance animation for hero title
        var heroTitle = instrumentHero.querySelector(".instrument-hero__title");
        if (heroTitle) {
          gsap.fromTo(
            heroTitle,
            {
              scale: 0.8,
              opacity: 0,
            },
            {
              scale: 1,
              opacity: 1,
              duration: 1.2,
              ease: "power3.out",
              delay: 0.3,
            },
          );
        }

        // CTA button entrance
        var heroCta = instrumentHero.querySelector(".instrument-hero__cta");
        if (heroCta) {
          gsap.fromTo(
            heroCta,
            {
              y: 50,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power2.out",
              delay: 0.8,
            },
          );
        }

        // Outline rows use CSS-only infinite animation, no scroll parallax
        // This keeps the marquee effect smooth without scroll interference
      }

      // =========================================================================
      // Section Animations - Video Left Text Right
      // =========================================================================

      var videoSections = document.querySelectorAll(
        ".paragraph--type--video-left-text-right",
      );
      videoSections.forEach(function (section) {
        var videoContainer = section.querySelector(".paragraph__wrapper--left");
        var textContent = section.querySelector(".paragraph__wrapper--right");

        if (videoContainer) {
          gsap.fromTo(
            videoContainer,
            {
              x: -60,
              opacity: 0,
            },
            {
              x: 0,
              opacity: 1,
              duration: 1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 80%",
                end: "top 50%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }

        if (textContent) {
          // Animate title
          var title = textContent.querySelector(".field-field-title");
          if (title) {
            gsap.fromTo(
              title,
              {
                y: 40,
                opacity: 0,
              },
              {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                  trigger: section,
                  start: "top 75%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }

          // Animate body text
          var body = textContent.querySelector(".field-field-body");
          if (body) {
            gsap.fromTo(
              body,
              {
                y: 30,
                opacity: 0,
              },
              {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.2,
                ease: "power2.out",
                scrollTrigger: {
                  trigger: section,
                  start: "top 75%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }
        }
      });

      // =========================================================================
      // Section Animations - FAQ Section
      // =========================================================================

      var faqSections = document.querySelectorAll(
        ".paragraph--type--faq-section",
      );
      faqSections.forEach(function (section) {
        // Section title
        var sectionTitle = section.querySelector(
          ".paragraph__wrapper > .field-field-title",
        );
        if (sectionTitle) {
          gsap.fromTo(
            sectionTitle,
            {
              y: 40,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 80%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }

        // FAQ items staggered
        var faqItems = section.querySelectorAll(
          ".paragraph--type--single-accordion",
        );
        if (faqItems.length) {
          gsap.fromTo(
            faqItems,
            {
              y: 30,
              opacity: 0,
            },
            {
              y: 0,
              opacity: 1,
              duration: 0.6,
              stagger: 0.1,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section.querySelector(".field-field-paragraphs"),
                start: "top 80%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }
      });

      // =========================================================================
      // Section Animations - Publications
      // =========================================================================

      var pubSections = document.querySelectorAll(
        ".paragraph--type--publications",
      );
      pubSections.forEach(function (section) {
        var title = section.querySelector(".field-field-title");
        var iframe = section.querySelector(".field-field-iframe");
        var link = section.querySelector(".field-field-link");

        if (title) {
          gsap.fromTo(
            title,
            { y: 40, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.8,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 80%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }

        if (iframe) {
          gsap.fromTo(
            iframe,
            { y: 60, opacity: 0, scale: 0.95 },
            {
              y: 0,
              opacity: 1,
              scale: 1,
              duration: 1,
              delay: 0.2,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 75%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }

        if (link) {
          gsap.fromTo(
            link,
            { y: 20, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.6,
              delay: 0.4,
              ease: "power2.out",
              scrollTrigger: {
                trigger: section,
                start: "top 60%",
                toggleActions: "play none none reverse",
              },
            },
          );
        }
      });

      // =========================================================================
      // Section Animations - Lab Plus
      // =========================================================================

      var labPlusSections = document.querySelectorAll(
        ".paragraph--type--labplus",
      );
      labPlusSections.forEach(function (section) {
        var top = section.querySelector(".paragraph__wrapper--top");
        var bottom = section.querySelector(".paragraph__wrapper--bottom");

        if (top) {
          // Icon/Logo
          var icon = top.querySelector(".field-field-icon");
          if (icon) {
            gsap.fromTo(
              icon,
              { y: 20, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.6,
                ease: "power2.out",
                scrollTrigger: {
                  trigger: section,
                  start: "top 80%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }

          // Title
          var title = top.querySelector(".field-field-title");
          if (title) {
            gsap.fromTo(
              title,
              { y: 30, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.8,
                delay: 0.1,
                ease: "power2.out",
                scrollTrigger: {
                  trigger: section,
                  start: "top 80%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }

          // Video/Laptop mockup with 3D effect
          var video = top.querySelector(".field-field-media-video-file");
          if (video) {
            gsap.fromTo(
              video,
              {
                y: 80,
                opacity: 0,
                rotateX: 15,
              },
              {
                y: 0,
                opacity: 1,
                rotateX: 5,
                duration: 1.2,
                delay: 0.3,
                ease: "power3.out",
                scrollTrigger: {
                  trigger: section,
                  start: "top 70%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }
        }

        // Feature cards
        if (bottom) {
          var cards = bottom.querySelectorAll(
            ".field-field-paragraphs .field__item",
          );
          if (cards.length) {
            gsap.fromTo(
              cards,
              { y: 40, opacity: 0 },
              {
                y: 0,
                opacity: 1,
                duration: 0.6,
                stagger: 0.1,
                ease: "power2.out",
                scrollTrigger: {
                  trigger: bottom,
                  start: "top 85%",
                  toggleActions: "play none none reverse",
                },
              },
            );
          }
        }
      });

      // =========================================================================
      // Smooth scroll for anchor links
      // =========================================================================

      var anchorLinks = document.querySelectorAll('a[href^="#"]');
      anchorLinks.forEach(function (link) {
        if (link.hasAttribute("data-anchor-attached")) return;
        link.setAttribute("data-anchor-attached", "true");

        link.addEventListener("click", function (e) {
          var href = this.getAttribute("href");
          if (href.length > 1) {
            var target = document.querySelector(href);
            if (target) {
              e.preventDefault();
              var header =
                document.getElementById("main-header") ||
                document.querySelector("header");
              var headerHeight = header ? header.offsetHeight : 80;
              var targetTop =
                target.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight;
              window.scrollTo({ top: targetTop, behavior: "smooth" });
            }
          }
        });
      });

      // =========================================================================
      // Refresh ScrollTrigger on dynamic content changes
      // =========================================================================

      setTimeout(function () {
        ScrollTrigger.refresh();
      }, 100);
    },
  };

  /* 
  | ============================================================================
  | INSTRUMENT HERO - Kinetic Animation for Full Page
  | Separate from teaser kinetic hero
  | ============================================================================
  */

  Drupal.behaviors.instrumentHeroKinetic = {
    attach: function (context, settings) {
      var hero = document.querySelector(".instrument-hero");

      if (hero && !hero.hasAttribute("data-instrument-hero-attached")) {
        hero.setAttribute("data-instrument-hero-attached", "true");

        // Add scroll-based speed variation
        var outlineRows = hero.querySelectorAll(
          ".instrument-hero__row--outline",
        );

        window.addEventListener(
          "scroll",
          function () {
            var scrollY = window.scrollY;
            var heroRect = hero.getBoundingClientRect();

            if (heroRect.top < window.innerHeight && heroRect.bottom > 0) {
              outlineRows.forEach(function (row, index) {
                var isRight = row.classList.contains(
                  "instrument-hero__row--right",
                );
                var speedModifier = 1 + scrollY * 0.0003;

                // Dynamically adjust animation speed
                row.style.animationDuration = 30 / speedModifier + "s";
              });
            }
          },
          { passive: true },
        );
      }
    },
  };

  /* 
  | ============================================================================
  | TEACHERS DOUBLE SLIDER - Infinite scroll with opposite directions
  | Two rows of teacher cards moving in opposite directions
  | ============================================================================
  */

  Drupal.behaviors.teachersDoubleSlider = {
    attach: function (context, settings) {
      var sliders = document.querySelectorAll(".teachers-double-slider");

      sliders.forEach(function (slider) {
        if (slider.hasAttribute("data-slider-attached")) return;
        slider.setAttribute("data-slider-attached", "true");

        var rows = slider.querySelectorAll(".teachers-slider-row");

        rows.forEach(function (row) {
          // Clone all items to create seamless infinite scroll
          var items = row.querySelectorAll(".teachers-slider-row__item");
          if (items.length === 0) return;

          // Clone items and append for seamless loop
          items.forEach(function (item) {
            var clone = item.cloneNode(true);
            row.appendChild(clone);
          });
        });
      });

      // Convert regular views block to double slider
      // First, check for blocks that were converted but had their content replaced by AJAX
      var convertedBlocks = document.querySelectorAll(
        ".block-views-blockteachers-block-2[data-converted], .block-views-blockteachers-block-1[data-converted]",
      );
      convertedBlocks.forEach(function (block) {
        // If the slider structure is gone (replaced by AJAX), remove data-converted to re-convert
        var hasSliderStructure = block.querySelector(
          ".teachers-double-slider__rows",
        );
        var hasRegularRows = block.querySelector(".view-content > .views-row");
        if (!hasSliderStructure && hasRegularRows) {
          block.removeAttribute("data-converted");
          block.removeAttribute("data-slider-attached");
        }
      });

      var viewsBlocks = document.querySelectorAll(
        ".block-views-blockteachers-block-2:not([data-converted]), .block-views-blockteachers-block-1:not([data-converted])",
      );

      viewsBlocks.forEach(function (block) {
        // Check if we're on an instrument page OR school page (not standalone teachers page)
        var isInstrumentPage = document.querySelector(".instrument-full-page");
        var isSchoolPage = document.querySelector(
          ".node--type-school.node--view-mode-full",
        );

        if (!isInstrumentPage && !isSchoolPage) return;

        block.setAttribute("data-converted", "true");

        var viewContent = block.querySelector(".view-content");
        if (!viewContent) return;

        var items = viewContent.querySelectorAll(".views-row");
        if (items.length === 0) return;

        // Get ALL items and split into two halves for different rows
        var itemsArray = Array.from(items);
        var midpoint = Math.ceil(itemsArray.length / 2);

        // Split teachers: first half for row 1, second half for row 2
        var firstHalf = itemsArray.slice(0, midpoint);
        var secondHalf = itemsArray.slice(midpoint);

        // Fallback: if only 1 teacher, both rows show the same teacher
        if (secondHalf.length === 0) {
          secondHalf = firstHalf;
        }

        // Calculate repeat count for each row separately (for seamless loop)
        var repeatCount1 = Math.max(4, Math.ceil(10 / firstHalf.length));
        var repeatCount2 = Math.max(4, Math.ceil(10 / secondHalf.length));

        // Create double slider structure
        var sliderHTML = '<div class="teachers-double-slider__rows">';

        // Row 1 - scrolls right - first half of teachers
        sliderHTML +=
          '<div class="teachers-slider-row teachers-slider-row--right">';
        for (var r = 0; r < repeatCount1; r++) {
          firstHalf.forEach(function (item) {
            sliderHTML +=
              '<div class="teachers-slider-row__item">' +
              item.innerHTML +
              "</div>";
          });
        }
        sliderHTML += "</div>";

        // Row 2 - scrolls left - second half of teachers
        sliderHTML +=
          '<div class="teachers-slider-row teachers-slider-row--left">';
        for (var r = 0; r < repeatCount2; r++) {
          secondHalf.forEach(function (item) {
            sliderHTML +=
              '<div class="teachers-slider-row__item">' +
              item.innerHTML +
              "</div>";
          });
        }
        sliderHTML += "</div>";

        sliderHTML += "</div>";

        // Replace grid with slider
        viewContent.innerHTML = sliderHTML;
        viewContent.style.display = "block";
        viewContent.style.padding = "0";
        viewContent.style.maxWidth = "none";

        // Add slider class to parent
        block.classList.add("teachers-double-slider");
      });
    },
  };

  /* 
  | ============================================================================
  | AJAX FILTER FOR TEACHERS BLOCK
  | Filter teachers without page redirect
  | ============================================================================
  */

  Drupal.behaviors.teachersBlockFilter = {
    attach: function (context, settings) {
      // Look for custom filter select in the block
      var filterSelects = document.querySelectorAll(
        ".teachers-double-slider__filter select, .view-teachers .view-filters select",
      );

      filterSelects.forEach(function (select) {
        if (select.hasAttribute("data-ajax-filter-attached")) return;
        select.setAttribute("data-ajax-filter-attached", "true");

        var parentBlock = select.closest(
          ".teachers-double-slider, .block-views-blockteachers-block-2, .block-views-blockteachers-block-1",
        );
        if (!parentBlock) return;

        select.addEventListener("change", function (e) {
          e.preventDefault();
          var schoolId = this.value;
          var viewContent = parentBlock.querySelector(
            ".view-content, .teachers-double-slider__rows",
          );

          if (!viewContent) return;

          // Show loading state
          viewContent.style.opacity = "0.5";
          viewContent.style.pointerEvents = "none";

          // Get current instrument from URL or page
          var instrumentPage = document.querySelector(".instrument-full-page");
          var instrumentId = instrumentPage
            ? instrumentPage.getAttribute("data-instrument-id")
            : null;

          // Build AJAX URL - filter teachers by school
          var baseUrl = drupalSettings.path.baseUrl || "/";
          var ajaxUrl = baseUrl + "views/ajax";

          var formData = new FormData();
          formData.append("view_name", "teachers");
          formData.append("view_display_id", "block_2");
          if (schoolId) {
            formData.append("field_school_target_id", schoolId);
          }
          if (instrumentId) {
            formData.append("field_instrument_target_id", instrumentId);
          }

          fetch(ajaxUrl, {
            method: "POST",
            body: formData,
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              // Find the HTML in the response
              if (data && data.length) {
                data.forEach(function (command) {
                  if (command.command === "insert" && command.data) {
                    viewContent.innerHTML = command.data;
                    viewContent.style.opacity = "1";
                    viewContent.style.pointerEvents = "auto";

                    // Re-attach behaviors for new content
                    Drupal.attachBehaviors(viewContent);
                  }
                });
              }
            })
            .catch(function (error) {
              console.error("Filter error:", error);
              viewContent.style.opacity = "1";
              viewContent.style.pointerEvents = "auto";
            });
        });
      });
    },
  };

  /* 
  | ============================================================================
  | PROGRAMS HERO - Split Cards Expand/Collapse
  | Migrated from React Programs.tsx component
  | ============================================================================
  */

  Drupal.behaviors.programsHero = {
    attach: function (context, settings) {
      var hero = document.querySelector(".programs-hero");

      if (!hero || hero.hasAttribute("data-programs-hero-attached")) return;
      hero.setAttribute("data-programs-hero-attached", "true");

      var cards = hero.querySelectorAll(".views-row");
      var activeIndex = Math.floor(cards.length / 2); // Start with middle card active

      // Set initial active state
      function setActiveCard(index) {
        cards.forEach(function (card, i) {
          if (i === index) {
            card.classList.add("is-active");
          } else {
            card.classList.remove("is-active");
          }
        });
        activeIndex = index;
      }

      // Initialize
      setActiveCard(activeIndex);

      // Add hover/click listeners
      cards.forEach(function (card, index) {
        // Mouse enter - expand card (desktop)
        card.addEventListener("mouseenter", function () {
          if (window.innerWidth >= 768) {
            setActiveCard(index);
          }
        });

        // Click handler
        card.addEventListener("click", function (e) {
          // If not active, expand it first (especially on mobile)
          if (activeIndex !== index) {
            e.preventDefault();
            setActiveCard(index);
            return;
          }

          // If active and click is not on the button, navigate
          var isButton = e.target.closest(".program-hero-card__btn");
          if (!isButton && window.innerWidth < 768) {
            // On mobile, clicking active card navigates
            var link = card.querySelector(".program-hero-card__btn");
            if (link) {
              window.location.href = link.href;
            }
          }
        });
      });

      // Swipe left/right on mobile to navigate cards
      var touchStartX = 0;
      var SWIPE_THRESHOLD = 50;

      hero.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true },
      );

      hero.addEventListener(
        "touchend",
        function (e) {
          var diff = touchStartX - e.changedTouches[0].screenX;
          if (Math.abs(diff) > SWIPE_THRESHOLD) {
            if (diff > 0) {
              setActiveCard(Math.min(activeIndex + 1, cards.length - 1));
            } else {
              setActiveCard(Math.max(activeIndex - 1, 0));
            }
          }
        },
        { passive: true },
      );

      // GSAP animation for quiz section entrance
      var quizSection = document.querySelector(".programs-quiz");
      if (quizSection && typeof gsap !== "undefined") {
        gsap.from(quizSection, {
          scrollTrigger: {
            trigger: quizSection,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
          opacity: 0,
          y: 50,
          duration: 0.8,
          ease: "power2.out",
        });
      }
    },
  };

  /*
  | ============================================================================
  | PROGRAMS QUIZ - Program Finder Widget
  | Dynamic question flow based on decision tree
  | ============================================================================
  */

  var QUIZ_STRINGS = {
    el: {
      title: "Βρες το Πρόγραμμα που σου Ταιριάζει",
      subtitle:
        "Απάντησε σε 3 απλές ερωτήσεις και θα σου προτείνουμε το ιδανικό πρόγραμμα",
      questions: {
        age: "Ποια είναι η ηλικία σου;",
        goal_teen: "Ποιος είναι ο στόχος σου;",
        goal_adult: "Ποιος είναι ο στόχος σου;",
        extras_teen: "Σε ενδιαφέρουν extra παροχές;",
        extras_adult: "Σε ενδιαφέρουν extra παροχές;",
        time_teen: "Πόσο χρόνο μπορείς να αφιερώσεις;",
        time_adult: "Πόσο χρόνο μπορείς να αφιερώσεις;",
        level_adult: "Σε τι επίπεδο θα έλεγες πως βρίσκεσαι;",
      },
      options: {
        toddler: "18 μηνών - 6 ετών",
        child: "6-11 ετών",
        teen: "11-17 ετών",
        adult: "18+ ετών",
        hobby: "Χόμπυ",
        serious: "Σοβαρή ενασχόληση",
        yes: "Ναι",
        no: "Όχι",
        limited: "Περιορισμένο",
        much: "Πολύ",
        moderate: "Αρκετό",
        primary: "Θα είναι η βασική μου ενασχόληση",
        beginner: "Αρχικό/Μέσο",
        advanced: "Προχωρημένο",
      },
      resultTitle: "Το ιδανικό πρόγραμμα για σένα είναι το",
      learnMore: "Μάθε Περισσότερα",
      tryAgain: "Δοκίμασε Ξανά",
      programs: {
        music4kids:
          "Πρόγραμμα ειδικά σχεδιασμένο για παιδιά 18 μηνών έως 6 ετών.",
        "kids-lab": "Πρόγραμμα ειδικά σχεδιασμένο για παιδιά έως 10 ετών.",
        colab:
          "Για όσους θέλουν να παίξουν και να δημιουργήσουν μαζί με άλλους.",
        "plus-30":
          "Ιδανικό για μαθητές με περιορισμένο χρόνο αλλά μεγάλους στόχους.",
        "plus-45": "Πιο εκτεταμένο μάθημα για γρήγορη πρόοδο και βάθος.",
        "band-program":
          "Παίξε σε συγκρότημα και βίωσε τη συλλογική μουσική δημιουργία.",
        professional:
          "Για επαγγελματίες μουσικούς που θέλουν να πάνε στο επόμενο επίπεδο.",
      },
    },
    en: {
      title: "Find the Program That Suits You",
      subtitle:
        "Answer 3 simple questions and we'll recommend the ideal program",
      questions: {
        age: "What is your age?",
        goal_teen: "What is your goal?",
        goal_adult: "What is your goal?",
        extras_teen: "Are you interested in extra services?",
        extras_adult: "Are you interested in extra services?",
        time_teen: "How much time can you dedicate?",
        time_adult: "How much time can you dedicate?",
        level_adult: "What level would you say you are at?",
      },
      options: {
        toddler: "18 months - 6 years old",
        child: "6-11 years old",
        teen: "11-17 years old",
        adult: "18+ years old",
        hobby: "Hobby",
        serious: "Serious involvement",
        yes: "Yes",
        no: "No",
        limited: "Limited",
        much: "A lot",
        moderate: "Enough",
        primary: "It will be my main activity",
        beginner: "Beginner/Intermediate",
        advanced: "Advanced",
      },
      resultTitle: "Your ideal program is",
      learnMore: "Learn More",
      tryAgain: "Try Again",
      programs: {
        music4kids:
          "Program specially designed for children from 18 months to 6 years old.",
        "kids-lab":
          "Program specially designed for children up to 10 years old.",
        colab: "For those who want to play and create together with others.",
        "plus-30": "Ideal for students with limited time but big goals.",
        "plus-45": "More extensive lesson for fast progress and depth.",
        "band-program":
          "Play in a band and experience collective music creation.",
        professional:
          "For professional musicians who want to go to the next level.",
      },
    },
  };

  Drupal.behaviors.programsQuiz = {
    attach: function (context, settings) {
      var quiz = document.getElementById("programs-quiz");

      if (!quiz || quiz.hasAttribute("data-quiz-attached")) return;
      quiz.setAttribute("data-quiz-attached", "true");

      var questionsContainer = document.getElementById("quiz-questions");
      var resultContainer = document.getElementById("quiz-result");
      var progressBars = quiz.querySelectorAll(".programs-quiz__progress-bar");

      if (!questionsContainer) return;

      // Resolve strings for the active language
      var currentLang = document.documentElement.lang === "el" ? "el" : "en";
      var s = QUIZ_STRINGS[currentLang];

      // Apply data-i18n strings to all labelled elements inside the quiz
      quiz.querySelectorAll("[data-i18n]").forEach(function (el) {
        var key = el.getAttribute("data-i18n");
        var parts = key.split(".");
        var value = s;
        for (var i = 0; i < parts.length; i++) {
          value = value && value[parts[i]];
        }
        if (typeof value === "string") {
          el.textContent = value;
        }
      });

      var questionHistory = ["age"];
      var currentQuestionId = "age";

      var langPrefix = currentLang === "en" ? "/en" : "";

      // Program data for results
      var programData = {
        music4kids: {
          name: "Music4Kids",
          description: s.programs["music4kids"],
          color: "#ee2b8c",
          url:
            currentLang === "en"
              ? "https://music4kids.gr/en"
              : "https://music4kids.gr",
        },
        "kids-lab": {
          name: "Kids' Lab",
          description: s.programs["kids-lab"],
          color: "#EF4444",
          url: langPrefix + "/node/17",
        },
        colab: {
          name: "Colab",
          description: s.programs["colab"],
          color: "#F59E0B",
          url: langPrefix + "/node/18",
        },
        "plus-30": {
          name: "Plus 30",
          description: s.programs["plus-30"],
          color: "#06B6D4",
          url: langPrefix + "/node/9",
        },
        "plus-45": {
          name: "Plus 45",
          description: s.programs["plus-45"],
          color: "#8B5CF6",
          url: langPrefix + "/node/19",
        },
        "band-program": {
          name: "Band Program",
          description: s.programs["band-program"],
          color: "#10B981",
          url: langPrefix + "/node/20",
        },
        professional: {
          name: "Professional",
          description: s.programs["professional"],
          color: "#EC4899",
          url: langPrefix + "/node/10",
        },
      };

      // Update progress bar
      function updateProgress(step) {
        progressBars.forEach(function (bar, index) {
          if (index < step) {
            bar.classList.add("programs-quiz__progress-bar--active");
          } else {
            bar.classList.remove("programs-quiz__progress-bar--active");
          }
        });
      }

      // Show question
      function showQuestion(questionId) {
        var questions = questionsContainer.querySelectorAll(
          ".programs-quiz__question",
        );
        questions.forEach(function (q) {
          q.classList.remove("programs-quiz__question--active");
        });

        var targetQuestion = questionsContainer.querySelector(
          '[data-question="' + questionId + '"]',
        );
        if (targetQuestion) {
          targetQuestion.classList.add("programs-quiz__question--active");
        }

        currentQuestionId = questionId;
      }

      // Show result
      function showResult(programId) {
        var program = programData[programId];
        if (!program) return;

        // Try to get program URL from the hero cards if available
        var heroCard = document.querySelector(
          '[data-program-id="' + programId + '"]',
        );
        var programUrl = program.url;
        if (heroCard) {
          var heroLink = heroCard.querySelector(".program-hero-card__btn");
          if (heroLink) {
            programUrl = heroLink.href;
          }
        }

        // Hide questions, show result
        questionsContainer.style.display = "none";
        resultContainer.style.display = "block";

        // Update result content
        var resultIcon = document.getElementById("result-icon");
        var resultName = document.getElementById("result-name");
        var resultDesc = document.getElementById("result-desc");
        var resultLink = document.getElementById("result-link");

        if (resultIcon) {
          resultIcon.style.backgroundColor = program.color;
        }
        if (resultName) {
          resultName.textContent = program.name;
          resultName.href = programUrl;
          resultName.style.color = program.color;
        }
        if (resultDesc) {
          resultDesc.textContent = program.description;
        }
        if (resultLink) {
          resultLink.href = programUrl;
        }

        // Update progress to complete
        updateProgress(4);
      }

      // Reset quiz
      function resetQuiz() {
        questionHistory = ["age"];
        currentQuestionId = "age";

        questionsContainer.style.display = "block";
        resultContainer.style.display = "none";

        showQuestion("age");
        updateProgress(1);
      }

      // Handle option click
      function handleOptionClick(e) {
        var option = e.target.closest(".programs-quiz__option");
        if (!option) return;

        var result = option.getAttribute("data-result");
        var nextQuestion = option.getAttribute("data-next");

        if (result) {
          // Direct result
          showResult(result);
        } else if (nextQuestion) {
          // Go to next question
          questionHistory.push(nextQuestion);
          showQuestion(nextQuestion);
          updateProgress(questionHistory.length);
        }
      }

      // Attach event listeners
      questionsContainer.addEventListener("click", handleOptionClick);

      // Restart button
      var restartBtn = document.getElementById("quiz-restart");
      if (restartBtn) {
        restartBtn.addEventListener("click", resetQuiz);
      }

      // Initialize
      updateProgress(1);
    },
  };

  /* 
  | ============================================================================
  | TEACHER DETAIL PAGE - Name Appending & Animations
  | Matches React TeacherDetail.tsx behavior
  | ============================================================================
  */

  Drupal.behaviors.teacherDetail = {
    attach: function (context, settings) {
      // Find teacher detail article
      var teacherArticle = document.querySelector(
        ".teacher-detail[data-teacher-name]",
      );
      if (!teacherArticle) {
        // Also check for legacy template
        teacherArticle = document.querySelector(
          ".node--type-teacher.full[data-history-node-id]",
        );
      }

      if (!teacherArticle) return;

      // Get teacher name
      var teacherName =
        teacherArticle.getAttribute("data-teacher-name") ||
        teacherArticle.querySelector("h1")?.textContent?.trim();

      if (!teacherName) return;

      // Extract first name for form placeholder
      var firstName = teacherName.split(" ")[0];

      // Greek accusative form fields
      var teacherLangcode =
        teacherArticle.getAttribute("data-teacher-langcode") || "";
      var teacherGender =
        teacherArticle.getAttribute("data-teacher-gender") || "";
      var teacherFormName =
        teacherArticle.getAttribute("data-teacher-form-name") || "";

      var isGreek = teacherLangcode === "el";
      var article =
        teacherGender === "female"
          ? "την"
          : teacherGender === "male"
            ? "τον"
            : "τον/την";

      // Greek: article + form_name (or firstName if no form_name); English: firstName only
      var appendName = isGreek && teacherFormName ? teacherFormName : firstName;
      var appendPrefix = isGreek ? " " + article + " " : "";

      // ========================================
      // Append teacher name to form block title
      // ========================================
      var formBlockTitle = document.querySelector(
        "#block-rkpt-bookanintroductorylessonwith .block__label",
      );

      if (
        formBlockTitle &&
        !formBlockTitle.hasAttribute("data-name-appended")
      ) {
        formBlockTitle.setAttribute("data-name-appended", "true");

        if (appendPrefix) {
          formBlockTitle.appendChild(document.createTextNode(appendPrefix));
        } else {
          formBlockTitle.appendChild(document.createTextNode(" "));
        }

        var nameSpan = document.createElement("span");
        nameSpan.className = "teacher-name-append";
        nameSpan.textContent = appendName;

        formBlockTitle.appendChild(nameSpan);
      }

      // ========================================
      // Update form message placeholder with teacher name
      // ========================================
      var messageTextarea = document.querySelector(
        "#block-rkpt-bookanintroductorylessonwith textarea[name='message']",
      );

      if (
        messageTextarea &&
        !messageTextarea.hasAttribute("data-placeholder-updated")
      ) {
        messageTextarea.setAttribute("data-placeholder-updated", "true");

        var placeholderName = isGreek
          ? article + " " + (teacherFormName || firstName)
          : firstName;
        var newPlaceholder =
          "Πες μας λίγα λόγια για εσένα και τι θα ήθελες να μάθεις από " +
          placeholderName +
          "...";
        messageTextarea.placeholder = newPlaceholder;
      }

      // ========================================
      // Set hidden teacher field value
      // ========================================
      var teacherHiddenField = document.querySelector(
        "input[name='teacher'][type='hidden']",
      );

      if (
        teacherHiddenField &&
        !teacherHiddenField.hasAttribute("data-value-set")
      ) {
        teacherHiddenField.setAttribute("data-value-set", "true");
        teacherHiddenField.value = teacherName;
      }

      // ========================================
      // Scroll animations using Intersection Observer
      // ========================================
      var animatedElements = document.querySelectorAll(
        ".teacher-detail .animate-fade-in, .teacher-detail .animate-slide-up",
      );

      if (animatedElements.length > 0 && "IntersectionObserver" in window) {
        var observerOptions = {
          root: null,
          rootMargin: "0px 0px -50px 0px",
          threshold: 0.1,
        };

        var animationObserver = new IntersectionObserver(function (
          entries,
          observer,
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        }, observerOptions);

        animatedElements.forEach(function (el) {
          if (!el.hasAttribute("data-animation-observed")) {
            el.setAttribute("data-animation-observed", "true");
            el.classList.add("animate-on-scroll");
            animationObserver.observe(el);
          }
        });
      }
    },
  };

  /* 
  | ============================================================================
  | SOCIAL LINK URL EXTRACTION
  | For teacher social media fields that only contain plain text URLs
  | ============================================================================
  */

  Drupal.behaviors.teacherSocialLinks = {
    attach: function (context, settings) {
      // Find social link containers that have plain text instead of links
      var socialLinks = document.querySelectorAll(
        ".teacher-detail__social-link[href='#'], .teacher-detail .social-wrapper .field__item",
      );

      socialLinks.forEach(function (el) {
        if (el.hasAttribute("data-url-processed")) return;
        el.setAttribute("data-url-processed", "true");

        // Check if this is a plain text field
        var text = el.textContent?.trim();
        if (text && !text.startsWith("http")) {
          // Try to construct a proper URL
          if (
            text.includes("facebook") ||
            text.includes("fb.") ||
            el.closest(".field-field-facebook")
          ) {
            var href = text.startsWith("http")
              ? text
              : "https://facebook.com/" + text.replace(/^@/, "");
            el.href = href;
          } else if (
            text.includes("instagram") ||
            text.includes("ig.") ||
            el.closest(".field-field-instagram")
          ) {
            var href = text.startsWith("http")
              ? text
              : "https://instagram.com/" + text.replace(/^@/, "");
            el.href = href;
          } else if (
            text.includes("youtube") ||
            text.includes("youtu.be") ||
            el.closest(".field-field-youtube")
          ) {
            var href = text.startsWith("http")
              ? text
              : "https://youtube.com/" + text.replace(/^@/, "");
            el.href = href;
          }
        }
      });
    },
  };

  /* 
  | ============================================================================
  | SMOOTH SCROLL FOR TEACHER BACK LINK
  | ============================================================================
  */

  Drupal.behaviors.teacherBackLink = {
    attach: function (context, settings) {
      var backLinks = document.querySelectorAll(".teacher-detail__back");

      backLinks.forEach(function (link) {
        if (link.hasAttribute("data-back-attached")) return;
        link.setAttribute("data-back-attached", "true");

        // Add hover animation
        link.addEventListener("mouseenter", function () {
          this.style.transform = "translateX(-4px)";
        });

        link.addEventListener("mouseleave", function () {
          this.style.transform = "translateX(0)";
        });
      });
    },
  };

  /* 
  | ============================================================================
  | SCHOOL PAGE - Locations Submenu & Form Behavior
  | Matches Loveable React design (music-school-reimagined)
  | ============================================================================
  */

  // School page submenu - smooth scroll & active state (Loveable Design)
  Drupal.behaviors.schoolSubmenu = {
    attach: function (context, settings) {
      var submenu = document.querySelector(
        ".menu-locations-submenu, .menu-camp-submenu",
      );
      if (!submenu || submenu.hasAttribute("data-submenu-attached")) return;
      submenu.setAttribute("data-submenu-attached", "true");

      var menuItems = submenu.querySelectorAll(".menu-item a");
      var sections = [];

      // Collect all target sections
      menuItems.forEach(function (link) {
        var href = link.getAttribute("href");
        if (href && href.startsWith("#")) {
          var targetId = href.substring(1);
          // Handle various ID formats (#top, #location, #about, etc.)
          var target = document.getElementById(targetId);

          // Also try to find sections by ID within the article
          if (!target) {
            target = document.querySelector('[id="' + targetId + '"]');
          }

          // Try wrapper classes if ID not found
          if (!target && targetId === "top") {
            target = document.querySelector(".wrapper__top, #hero");
          }
          if (!target && targetId === "school") {
            target = document.querySelector(".wrapper__gallery, #gallery");
          }

          if (target) {
            sections.push({ link: link, target: target, id: targetId });
          }
        }
      });

      // Smooth scroll on click
      menuItems.forEach(function (link) {
        link.addEventListener("click", function (e) {
          var href = this.getAttribute("href");
          if (href && href.startsWith("#")) {
            e.preventDefault();
            var targetId = href.substring(1);
            var target = document.getElementById(targetId);

            // Fallback selectors
            if (!target && targetId === "top") {
              target = document.querySelector(
                ".wrapper__top, #hero, .node--type-school",
              );
            }
            if (!target && targetId === "school") {
              target = document.querySelector(".wrapper__gallery, #gallery");
            }
            if (!target) {
              target = document.querySelector('[id="' + targetId + '"]');
            }

            if (target) {
              var headerOffset = 160; // Header + submenu height
              var elementPosition = target.getBoundingClientRect().top;
              var offsetPosition =
                elementPosition + window.pageYOffset - headerOffset;

              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
              });

              // Update active state
              menuItems.forEach(function (item) {
                item.classList.remove("is-active");
                item.parentElement.classList.remove("is-active");
              });
              this.classList.add("is-active");
              this.parentElement.classList.add("is-active");
            }
          }
        });
      });

      // Update active state on scroll
      if (sections.length > 0) {
        var scrollHandler = function () {
          var scrollPos = window.scrollY + 200;
          var activeFound = false;

          // Check sections in reverse order to properly handle overlapping areas
          for (var i = sections.length - 1; i >= 0; i--) {
            var section = sections[i];
            var sectionTop = section.target.offsetTop;
            var sectionHeight = section.target.offsetHeight;

            if (
              scrollPos >= sectionTop &&
              scrollPos < sectionTop + sectionHeight
            ) {
              if (!activeFound) {
                menuItems.forEach(function (item) {
                  item.classList.remove("is-active");
                  item.parentElement.classList.remove("is-active");
                });
                section.link.classList.add("is-active");
                section.link.parentElement.classList.add("is-active");
                activeFound = true;
              }
              break;
            }
          }

          // If at very top of page, activate first menu item
          if (!activeFound && window.scrollY < 100) {
            menuItems.forEach(function (item) {
              item.classList.remove("is-active");
              item.parentElement.classList.remove("is-active");
            });
            if (menuItems.length > 0) {
              menuItems[0].classList.add("is-active");
              menuItems[0].parentElement.classList.add("is-active");
            }
          }
        };

        window.addEventListener("scroll", scrollHandler, { passive: true });
        scrollHandler(); // Run once on init
      }
    },
  };

  // School form - pre-select and lock location to the current school
  (function () {
    var formContainer = document.querySelector(".form[data-school-location]");
    if (!formContainer) return;

    var schoolId = formContainer.getAttribute("data-school-location");
    if (!schoolId) return;

    var locationSelect = document.getElementById("edit-location");
    if (!locationSelect) return;

    // Pre-select the matching option
    locationSelect.value = schoolId;
    locationSelect.dispatchEvent(new Event("change", { bubbles: true }));

    // Lock — disabled selects don't submit, so add a hidden input for the value
    locationSelect.disabled = true;

    var hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "location";
    hidden.value = schoolId;
    locationSelect.parentNode.appendChild(hidden);
  })();

  // School form - Dynamic submit button based on plan selection (Loveable Design)
  Drupal.behaviors.schoolFormPlanSelection = {
    attach: function (context, settings) {
      var schoolForms = document.querySelectorAll(
        ".node--type-school .webform-submission-form, " +
          "#webform-submission-school-form-node-4-add-form, " +
          "#webform-submission-school-form-node-6-add-form, " +
          ".webform-submission-contact-block-form",
      );

      schoolForms.forEach(function (form) {
        if (form.hasAttribute("data-plan-attached")) return;
        form.setAttribute("data-plan-attached", "true");

        var planRadios = form.querySelectorAll('input[name="plan_selection"]');
        var submitBtn = form.querySelector(
          'input[type="submit"], button[type="submit"]',
        );
        var planCards = form.querySelectorAll(".form-item-plan-selection");

        if (!planRadios.length || !submitBtn) return;

        // Preselect first option if none selected
        var isAnyChecked = false;
        planRadios.forEach(function (r) {
          if (r.checked) isAnyChecked = true;
        });

        if (!isAnyChecked && planRadios.length > 0) {
          planRadios[0].checked = true;
        }

        var isElLang = document.documentElement.lang === "el";
        var btnStrings = {
          freeTrial: isElLang
            ? "Κλείσε δωρεάν μάθημα γνωριμίας"
            : "Book free trial lesson",
          oneMonth: isElLang
            ? "Κλείσε 1 μήνα με 50% έκπτωση"
            : "Book 1 month with 50% off",
          submit: isElLang ? "Υποβολή" : "Submit",
        };

        // Button config with text and colors for each plan
        var buttonConfig = {
          "Free Lesson": {
            text: btnStrings.freeTrial,
            bgColor: "#ee3f44",
            hoverColor: "#d63a3f",
          },
          "Free Trial Lesson": {
            text: btnStrings.freeTrial,
            bgColor: "#ee3f44",
            hoverColor: "#d63a3f",
          },
          "1 Month -50%": {
            text: btnStrings.oneMonth,
            bgColor: "#8b5cf6",
            hoverColor: "#7c3aed",
          },
          "1 Month with 50% Off": {
            text: btnStrings.oneMonth,
            bgColor: "#8b5cf6",
            hoverColor: "#7c3aed",
          },
          default: {
            text: btnStrings.submit,
            bgColor: "#ee3f44",
            hoverColor: "#d63a3f",
          },
        };

        // Function to update button text and style with animation
        function updateButton(value) {
          var config = buttonConfig[value] || buttonConfig["default"];

          // Add fade-out animation
          submitBtn.style.opacity = "0";
          submitBtn.style.transform = "scale(0.98)";

          setTimeout(function () {
            submitBtn.value = config.text;
            if (submitBtn.tagName === "BUTTON") {
              submitBtn.textContent = config.text;
            }
            // Update colors
            submitBtn.style.backgroundColor = config.bgColor;
            submitBtn.dataset.hoverColor = config.hoverColor;

            // Fade back in
            submitBtn.style.opacity = "1";
            submitBtn.style.transform = "scale(1)";
          }, 150);
        }

        // Handle hover states with dynamic color
        submitBtn.addEventListener("mouseenter", function () {
          var hoverColor = this.dataset.hoverColor || "#d63a3f";
          this.style.backgroundColor = hoverColor;
        });

        submitBtn.addEventListener("mouseleave", function () {
          var config =
            buttonConfig[
              form.querySelector('input[name="plan_selection"]:checked')?.value
            ] || buttonConfig["default"];
          this.style.backgroundColor = config.bgColor;
        });

        // Listen for radio changes
        planRadios.forEach(function (radio) {
          radio.addEventListener("change", function () {
            if (this.checked) {
              updateButton(this.value);

              // Update card visual states
              planCards.forEach(function (card) {
                card.classList.remove("is-selected");
              });
              var parentCard = this.closest(".form-item-plan-selection");
              if (parentCard) {
                parentCard.classList.add("is-selected");
              }
            }
          });

          // Set initial button state if radio is already checked
          if (radio.checked) {
            var config = buttonConfig[radio.value] || buttonConfig["default"];
            submitBtn.value = config.text;
            submitBtn.style.backgroundColor = config.bgColor;
            submitBtn.dataset.hoverColor = config.hoverColor;
            if (submitBtn.tagName === "BUTTON") {
              submitBtn.textContent = config.text;
            }
            var parentCard = radio.closest(".form-item-plan-selection");
            if (parentCard) {
              parentCard.classList.add("is-selected");
            }
          }
        });

        // Handle card click (click anywhere on card to select)
        planCards.forEach(function (card) {
          card.style.cursor = "pointer";
          card.addEventListener("click", function (e) {
            // Don't trigger if clicking directly on radio
            if (e.target.type === "radio") return;

            var radio = this.querySelector('input[type="radio"]');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            }
          });
        });

        // Add transition styles to button
        submitBtn.style.transition =
          "opacity 0.15s ease, transform 0.15s ease, background-color 0.2s ease";
      });
    },
  };

  // School page section animations on scroll (Loveable Design)
  Drupal.behaviors.schoolSectionAnimations = {
    attach: function (context, settings) {
      var schoolPage = document.querySelector(".node--type-school");
      if (!schoolPage || schoolPage.hasAttribute("data-animations-attached"))
        return;
      schoolPage.setAttribute("data-animations-attached", "true");

      // Animate sections on scroll
      var sections = schoolPage.querySelectorAll(
        ".wrapper__middle, .wrapper__bottom, .wrapper__gallery, " +
          ".views-element-container, .block-block-content, " +
          ".school-teachers, .school-gallery, .block-webform",
      );

      // Animate individual cards/items within sections
      var cards = schoolPage.querySelectorAll(
        ".teacher-card, .gallery-item, .form-item-plan-selection, " +
          ".contact-item, .location-card",
      );

      if (!sections.length && !cards.length) return;

      // Intersection Observer for scroll animations
      var observerOptions = {
        root: null,
        rootMargin: "-50px 0px",
        threshold: 0.1,
      };

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            // Unobserve after animation to prevent re-triggering
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      // Set initial state for sections
      sections.forEach(function (section, index) {
        section.style.opacity = "0";
        section.style.transform = "translateY(40px)";
        section.style.transition =
          "opacity 0.6s ease " +
          index * 0.1 +
          "s, transform 0.6s ease " +
          index * 0.1 +
          "s";
        observer.observe(section);
      });

      // Set initial state for cards with stagger
      cards.forEach(function (card, index) {
        card.style.opacity = "0";
        card.style.transform = "translateY(30px) scale(0.95)";
        var delay = (index % 4) * 0.1; // Stagger in groups of 4
        card.style.transition =
          "opacity 0.5s ease " +
          delay +
          "s, transform 0.5s ease " +
          delay +
          "s";
        observer.observe(card);
      });

      // Hero animation on load (wrapper__top)
      var heroSection = schoolPage.querySelector(".wrapper__top");
      if (heroSection) {
        var heroLeft = heroSection.querySelector(".wrapper__top--left");
        var heroRight = heroSection.querySelector(".wrapper__top--right");

        if (heroLeft) {
          heroLeft.style.opacity = "0";
          heroLeft.style.transform = "translateX(-40px)";
          setTimeout(function () {
            heroLeft.style.transition =
              "opacity 0.8s ease, transform 0.8s ease";
            heroLeft.style.opacity = "1";
            heroLeft.style.transform = "translateX(0)";
          }, 200);
        }

        if (heroRight) {
          heroRight.style.opacity = "0";
          heroRight.style.transform = "translateX(40px)";
          setTimeout(function () {
            heroRight.style.transition =
              "opacity 0.8s ease, transform 0.8s ease";
            heroRight.style.opacity = "1";
            heroRight.style.transform = "translateX(0)";
          }, 400);
        }
      }

      // Add is-visible style handler
      var style = document.createElement("style");
      style.textContent =
        ".is-visible { opacity: 1 !important; transform: translateY(0) !important; }";
      document.head.appendChild(style);
    },
  };

  // Teacher cards section on school page - infinite scroll animation
  Drupal.behaviors.teacherCardsInfiniteScroll = {
    attach: function (context, settings) {
      var teacherViews = document.querySelectorAll(
        ".view-teachers .view-content",
      );

      teacherViews.forEach(function (viewContent) {
        if (viewContent.hasAttribute("data-infinite-attached")) return;
        viewContent.setAttribute("data-infinite-attached", "true");

        var cards = viewContent.querySelectorAll(".views-row");
        if (cards.length < 3) return; // Need at least 3 cards for effect

        // Clone cards for infinite scroll effect
        var container = document.createElement("div");
        container.className = "infinite-scroll-row";
        container.style.cssText = "overflow: hidden; padding: 0.5rem 0;";

        var inner = document.createElement("div");
        inner.className = "infinite-scroll-content";
        inner.style.cssText =
          "display: flex; gap: 1rem; will-change: transform;";

        // Duplicate cards multiple times for seamless loop
        for (var i = 0; i < 4; i++) {
          cards.forEach(function (card) {
            var clone = card.cloneNode(true);
            clone.style.flexShrink = "0";
            clone.style.width = "180px";
            inner.appendChild(clone);
          });
        }

        container.appendChild(inner);

        // Calculate total width for animation
        var cardWidth = 180 + 16; // card width + gap
        var totalWidth = cardWidth * cards.length;

        // Add CSS animation
        var animStyle = document.createElement("style");
        animStyle.textContent = `
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-${totalWidth}px); }
          }
          @keyframes scrollRight {
            0% { transform: translateX(-${totalWidth}px); }
            100% { transform: translateX(0); }
          }
        `;
        document.head.appendChild(animStyle);

        inner.style.animation =
          "scrollLeft " + cards.length * 5 + "s linear infinite";

        // Pause on hover
        container.addEventListener("mouseenter", function () {
          inner.style.animationPlayState = "paused";
        });
        container.addEventListener("mouseleave", function () {
          inner.style.animationPlayState = "running";
        });

        // Replace original content with infinite scroll version (desktop only)
        if (window.innerWidth >= 768) {
          viewContent.innerHTML = "";
          viewContent.appendChild(container);
        }
      });
    },
  };

  /* 
  | ============================================================================
  | SCHOOL PAGE - Simple Gallery Lightbox
  | Just find images in gallery section and show in lightbox on click
  | ============================================================================
  */

  Drupal.behaviors.schoolGalleryLightbox = {
    attach: function (context, settings) {
      var galleryGrid = document.querySelector(
        ".wrapper__gallery .gallery-grid",
      );
      var lightbox = document.querySelector(".gallery-lightbox");

      if (!galleryGrid || !lightbox) return;
      if (galleryGrid.hasAttribute("data-gallery-init")) return;
      galleryGrid.setAttribute("data-gallery-init", "true");

      // Find all images in gallery
      var images = galleryGrid.querySelectorAll("img");
      if (images.length === 0) return;

      var currentIndex = 0;
      var imageList = [];

      // Build image list and add click handlers
      images.forEach(function (img, index) {
        imageList.push({
          src: img.src,
          alt: img.alt || "Gallery image",
        });

        // Make clickable
        img.style.cursor = "pointer";
        img.addEventListener("click", function () {
          openLightbox(index);
        });
      });

      // Lightbox elements
      var lightboxImg = lightbox.querySelector(".gallery-lightbox__image");
      var closeBtn = lightbox.querySelector(".gallery-lightbox__close");
      var prevBtn = lightbox.querySelector(".gallery-lightbox__prev");
      var nextBtn = lightbox.querySelector(".gallery-lightbox__next");
      var currentSpan = lightbox.querySelector(".current");
      var totalSpan = lightbox.querySelector(".total");
      var backdrop = lightbox.querySelector(".gallery-lightbox__backdrop");

      // Update counter
      if (totalSpan) totalSpan.textContent = imageList.length;

      function showImage(index) {
        currentIndex = index;
        if (lightboxImg && imageList[index]) {
          lightboxImg.src = imageList[index].src;
          lightboxImg.alt = imageList[index].alt;
        }
        if (currentSpan) currentSpan.textContent = index + 1;
      }

      function openLightbox(index) {
        showImage(index);
        lightbox.classList.add("active");
        document.body.style.overflow = "hidden";
      }

      function closeLightbox() {
        lightbox.classList.remove("active");
        document.body.style.overflow = "";
      }

      function prevImage() {
        currentIndex = (currentIndex - 1 + imageList.length) % imageList.length;
        showImage(currentIndex);
      }

      function nextImage() {
        currentIndex = (currentIndex + 1) % imageList.length;
        showImage(currentIndex);
      }

      // Event listeners
      if (closeBtn) closeBtn.addEventListener("click", closeLightbox);
      if (prevBtn) prevBtn.addEventListener("click", prevImage);
      if (nextBtn) nextBtn.addEventListener("click", nextImage);
      if (backdrop) backdrop.addEventListener("click", closeLightbox);

      // Keyboard navigation
      document.addEventListener("keydown", function (e) {
        if (!lightbox.classList.contains("active")) return;
        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowLeft") prevImage();
        if (e.key === "ArrowRight") nextImage();
      });
    },
  };

  /* 
  | ============================================================================
  | BANANA HERO - Animated Scrolling Media Rows
  | Migrated from React BananaHero.tsx (music-school-reimagined)
  | Uses GSAP for title word animations
  | ============================================================================
  */

  Drupal.behaviors.bananaHero = {
    attach: function (context, settings) {
      var bananaHeros = context.querySelectorAll
        ? context.querySelectorAll("[data-banana-hero]")
        : [];

      bananaHeros.forEach(function (hero) {
        if (hero.hasAttribute("data-banana-hero-attached")) return;
        hero.setAttribute("data-banana-hero-attached", "true");

        // ---------------------------------------------------------------------
        // Video Autoplay Setup
        // ---------------------------------------------------------------------
        var videos = hero.querySelectorAll("video");
        videos.forEach(function (video) {
          video.removeAttribute("controls");
          video.setAttribute("autoplay", "");
          video.setAttribute("loop", "");
          video.setAttribute("muted", "");
          video.setAttribute("playsinline", "");
          video.muted = true;

          // Use IntersectionObserver as the sole play/pause controller.
          // Calling play() eagerly then pause() from the observer creates an
          // AbortError race; safePause waits for any pending play() Promise
          // before pausing so the race cannot occur.
          var pendingPlay = null;

          function safePlay(vid) {
            pendingPlay = vid.play();
            if (pendingPlay !== undefined) {
              pendingPlay.catch(function () {
                pendingPlay = null;
              });
            }
          }

          function safePause(vid) {
            if (pendingPlay !== undefined && pendingPlay !== null) {
              pendingPlay
                .then(function () {
                  vid.pause();
                })
                .catch(function () {});
              pendingPlay = null;
            } else if (!vid.paused) {
              vid.pause();
            }
          }

          if ("IntersectionObserver" in window) {
            var videoObserver = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                    safePlay(entry.target);
                  } else {
                    safePause(entry.target);
                  }
                });
              },
              { threshold: 0.1 },
            );
            videoObserver.observe(video);
          } else {
            safePlay(video);
          }
        });

        // ---------------------------------------------------------------------
        // GSAP Title Animation
        // ---------------------------------------------------------------------
        var words = hero.querySelectorAll(".banana-hero__word");

        if (words.length > 0 && typeof gsap !== "undefined") {
          // Set initial state
          gsap.set(words, {
            opacity: 0,
            y: 30,
            scale: 0.9,
          });

          // Animate words with stagger
          gsap.to(words, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            delay: 0.5,
            ease: "power3.out",
            stagger: 0.15,
            onComplete: function () {
              // Add visible class for CSS fallback
              words.forEach(function (word) {
                word.classList.add("is-visible");
              });
            },
          });
        } else {
          // Fallback: show words immediately if GSAP not available
          words.forEach(function (word) {
            word.classList.add("is-visible");
            word.style.opacity = "1";
            word.style.transform = "none";
          });
        }

        // ---------------------------------------------------------------------
        // Dynamic Animation Duration from data attributes
        // Force animation with !important to bypass reduced motion settings
        // ---------------------------------------------------------------------
        var rows = hero.querySelectorAll(".banana-hero__row");
        rows.forEach(function (row) {
          var duration = row.getAttribute("data-duration");
          if (duration) {
            var track = row.querySelector(".banana-hero__track");
            if (track) {
              // Force all animation properties with !important to bypass
              // prefers-reduced-motion: reduce, which sets animation-name: none
              // via the animation shorthand — that property must be overridden
              // explicitly or the rows won't scroll on Windows "Reduce animations".
              track.style.setProperty(
                "animation-name",
                "banana-hero-scroll",
                "important",
              );
              track.style.setProperty(
                "animation-duration",
                duration + "s",
                "important",
              );
              track.style.setProperty(
                "animation-play-state",
                "running",
                "important",
              );
              track.style.setProperty(
                "animation-iteration-count",
                "infinite",
                "important",
              );
              track.style.setProperty(
                "animation-timing-function",
                "linear",
                "important",
              );
            }
          }
        });

        // ---------------------------------------------------------------------
        // Parallax effect on scroll (optional enhancement)
        // ---------------------------------------------------------------------
        if (
          typeof gsap !== "undefined" &&
          typeof ScrollTrigger !== "undefined"
        ) {
          gsap.registerPlugin(ScrollTrigger);

          // Subtle parallax on rows
          rows.forEach(function (row, index) {
            var direction = index % 2 === 0 ? 1 : -1;
            var track = row.querySelector(".banana-hero__track");

            if (track) {
              gsap.to(track, {
                x: direction * 50,
                ease: "none",
                scrollTrigger: {
                  trigger: hero,
                  start: "top bottom",
                  end: "bottom top",
                  scrub: 1,
                },
              });
            }
          });
        }
      });
    },
  };

  /* 
  | ============================================================================
  | INSTRUMENT CAROUSEL 3D - Rotating 3D Image Carousel
  | Migrated from React InstrumentCarousel3D.tsx (music-school-reimagined)
  | Uses GSAP for continuous rotation with scroll-triggered speed boost
  | 
  | IMPORTANT: Only the carousel TRACK rotates via GSAP.
  | Individual panels have STATIC CSS transforms that position them in 3D space.
  | When the track rotates, all panels orbit together.
  | ============================================================================
  */

  Drupal.behaviors.instrumentCarousel3D = {
    attach: function (context, settings) {
      var carousels = context.querySelectorAll
        ? context.querySelectorAll("[data-carousel-3d]")
        : [];

      carousels.forEach(function (section) {
        if (section.hasAttribute("data-carousel-3d-attached")) return;
        section.setAttribute("data-carousel-3d-attached", "true");

        var carouselTrack = section.querySelector("[data-carousel-track]");
        if (!carouselTrack) return;

        // Check if GSAP is available
        if (typeof gsap === "undefined") {
          console.warn("GSAP not available for 3D carousel");
          return;
        }

        // Register ScrollTrigger if available
        if (typeof ScrollTrigger !== "undefined") {
          gsap.registerPlugin(ScrollTrigger);
        }

        // ---------------------------------------------------------------------
        // Configuration - matching React component exactly
        // ---------------------------------------------------------------------
        var rotation = 0;
        var scrollSpeed = 0;
        var baseSpeed = 0.15; // Base rotation speed (degrees per frame)

        // ---------------------------------------------------------------------
        // Animation Loop - Continuous rotation of the TRACK only
        // This is exactly how React does it: gsap.set(carouselRef.current, { rotationY: rotation })
        // ---------------------------------------------------------------------
        function tick() {
          rotation += baseSpeed + scrollSpeed;
          scrollSpeed *= 0.95; // Decay scroll boost

          // ONLY rotate the track - panels stay in their CSS-defined positions
          gsap.set(carouselTrack, { rotationY: rotation });
        }

        // Add to GSAP ticker for smooth 60fps animation
        gsap.ticker.add(tick);

        // ---------------------------------------------------------------------
        // Scroll-Triggered Speed Boost
        // When user scrolls, carousel spins faster temporarily
        // Use absolute value so scrolling in either direction boosts rotation
        // in the same direction (keeps spinning the same way, just faster)
        // ---------------------------------------------------------------------
        var scrollTriggerInstance = null;

        if (typeof ScrollTrigger !== "undefined") {
          scrollTriggerInstance = ScrollTrigger.create({
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            onUpdate: function (self) {
              // Boost rotation speed based on scroll velocity
              // Use Math.abs so scrolling either direction speeds up rotation
              var velocity = self.getVelocity();
              scrollSpeed = Math.abs(velocity) * 0.001;
            },
          });
        }

        // ---------------------------------------------------------------------
        // Reduced Motion Support
        // ---------------------------------------------------------------------
        var prefersReducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)",
        );

        function handleReducedMotion() {
          // if (prefersReducedMotion.matches) {
          //   baseSpeed = 0;
          //   gsap.ticker.remove(tick);
          // } else {
          baseSpeed = 0.15;
          gsap.ticker.add(tick);
          // }
        }

        handleReducedMotion();
        prefersReducedMotion.addEventListener("change", handleReducedMotion);
      });
    },
  };

  /* 
  | ============================================================================
  | TEXT COMPONENT - "Who We Are" Section
  | Migrated from React Index.tsx (music-school-reimagined)
  | Simple scroll-triggered fade-in animation
  | ============================================================================
  */

  Drupal.behaviors.textComponent = {
    attach: function (context, settings) {
      var sections = context.querySelectorAll
        ? context.querySelectorAll("[data-animate]")
        : [];

      sections.forEach(function (section) {
        // Only target text-component paragraphs
        if (
          !section.classList.contains("text-component") &&
          !section.classList.contains("paragraph--type--text-component")
        ) {
          return;
        }

        if (section.hasAttribute("data-animate-attached")) return;
        section.setAttribute("data-animate-attached", "true");

        // Simple IntersectionObserver for scroll animation
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.2,
            rootMargin: "0px 0px -50px 0px",
          },
        );

        observer.observe(section);
      });
    },
  };

  /* 
  | ============================================================================
  | VISION COMPONENT - Full-screen Vision Section
  | Migrated from React Index.tsx (music-school-reimagined)
  | GSAP ScrollTrigger timeline animation
  | ============================================================================
  */

  Drupal.behaviors.visionComponent = {
    attach: function (context, settings) {
      var sections = context.querySelectorAll
        ? context.querySelectorAll("[data-vision-animate]")
        : [];

      sections.forEach(function (section) {
        if (section.hasAttribute("data-vision-attached")) return;
        section.setAttribute("data-vision-attached", "true");

        // Check if GSAP is available
        if (typeof gsap === "undefined") {
          // Fallback: use CSS transitions
          section.classList.add("is-animated");
          return;
        }

        // Register ScrollTrigger if available
        if (typeof ScrollTrigger !== "undefined") {
          gsap.registerPlugin(ScrollTrigger);
        }

        // Select elements
        var title = section.querySelector(".field-field-title");
        var decorativeElements = section.querySelectorAll(
          ".decorative-element",
        );
        var subtitle = section.querySelector(".field-field-subtitle");
        var body = section.querySelector(".field-field-body");
        var link = section.querySelector(".field-field-link");

        // Create GSAP timeline with ScrollTrigger
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none reverse",
          },
        });

        // Headline animation
        if (title) {
          tl.from(title, {
            opacity: 0,
            y: 60,
            scale: 0.9,
            duration: 1,
            ease: "power3.out",
          });
        }

        // Decorative line animation
        if (decorativeElements.length > 0) {
          tl.from(
            decorativeElements,
            {
              opacity: 0,
              scaleX: 0,
              duration: 0.6,
              stagger: 0.1,
              ease: "power2.out",
            },
            "-=0.5",
          );
        }

        // Subtitle (first paragraph) animation
        if (subtitle) {
          tl.from(
            subtitle,
            {
              opacity: 0,
              y: 40,
              duration: 0.8,
              ease: "power2.out",
            },
            "-=0.3",
          );
        }

        // Body (quote) animation
        if (body) {
          tl.from(
            body,
            {
              opacity: 0,
              y: 40,
              scale: 0.95,
              duration: 0.8,
              ease: "power2.out",
            },
            "-=0.4",
          );
        }

        // CTA Button animation
        if (link) {
          tl.from(
            link,
            {
              opacity: 0,
              y: 30,
              scale: 0.9,
              duration: 0.6,
              ease: "back.out(1.7)",
            },
            "-=0.4",
          );
        }
      });
    },
  };

  /* 
  | ============================================================================
  | SCROLL TO TOP BUTTON
  | Migrated from React ScrollToTopButton.tsx (music-school-reimagined)
  | Shows/hides button based on scroll position, scrolls to top on click
  | ============================================================================
  */

  Drupal.behaviors.scrollToTop = {
    attach: function (context, settings) {
      var scrollBtn = document.getElementById("scroll-to-top-btn");

      if (!scrollBtn || scrollBtn.hasAttribute("data-scroll-attached")) {
        return;
      }

      scrollBtn.setAttribute("data-scroll-attached", "true");

      var scrollThreshold = 300;

      // Toggle button visibility based on scroll position
      function toggleVisibility() {
        if (window.scrollY > scrollThreshold) {
          scrollBtn.classList.add("is-visible");
        } else {
          scrollBtn.classList.remove("is-visible");
        }
      }

      // Scroll to top with smooth animation
      function scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }

      // Initial check
      toggleVisibility();

      // Listen for scroll events
      window.addEventListener("scroll", toggleVisibility, { passive: true });

      // Click handler
      scrollBtn.addEventListener("click", scrollToTop);
    },
  };

  /* 
  | ============================================================================
  | EVENTS & NEWS PAGE - Mobile Tabs
  | Matches React Events.tsx mobile tab toggle behavior
  | Shows tabs only below 768px, toggles between news and events sections
  | ============================================================================
  */

  Drupal.behaviors.eventsMobileTabs = {
    attach: function (context, settings) {
      // Only run on events & news page
      var regionContent = document.querySelector(".region-content");
      var newsBlock = document.querySelector(
        ".block-views-blocknews-events-block-1",
        ".block-views-blocknews-events-block-2",
      );
      var eventsBlock = document.querySelector(
        ".block-views-blockevents-block-1",
        ".block-views-blocknews-events-block-2",
      );

      // Exit if not on the right page or already attached
      if (
        !regionContent ||
        !newsBlock ||
        !eventsBlock ||
        regionContent.hasAttribute("data-mobile-tabs-attached")
      ) {
        return;
      }

      regionContent.setAttribute("data-mobile-tabs-attached", "true");

      // Count items in each view
      var newsCount =
        newsBlock.querySelectorAll(".view-content .views-row").length || 0;
      var eventsCount =
        eventsBlock.querySelectorAll(".view-content .views-row").length || 0;

      // Create mobile tabs HTML
      var tabsHTML =
        '<div class="events-mobile-tabs">' +
        '<button class="events-mobile-tab is-active" data-tab="news" type="button">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">' +
        '<path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"></path>' +
        '<path d="M18 14h-8"></path>' +
        '<path d="M15 18h-5"></path>' +
        '<path d="M10 6h8v4h-8V6Z"></path>' +
        "</svg>" +
        '<span class="tab-label">Τελευταία Νέα</span>' +
        '<span class="tab-badge">' +
        newsCount +
        "</span>" +
        "</button>" +
        '<button class="events-mobile-tab" data-tab="events" type="button">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">' +
        '<path d="M8 2v4"></path>' +
        '<path d="M16 2v4"></path>' +
        '<rect width="18" height="18" x="3" y="4" rx="2"></rect>' +
        '<path d="M3 10h18"></path>' +
        '<path d="M8 14h.01"></path>' +
        '<path d="M12 14h.01"></path>' +
        '<path d="M16 14h.01"></path>' +
        '<path d="M8 18h.01"></path>' +
        '<path d="M12 18h.01"></path>' +
        '<path d="M16 18h.01"></path>' +
        "</svg>" +
        '<span class="tab-label">Events</span>' +
        '<span class="tab-badge">' +
        eventsCount +
        "</span>" +
        "</button>" +
        "</div>";

      // Create tabs element
      var tabsContainer = document.createElement("div");
      tabsContainer.innerHTML = tabsHTML;
      var tabsElement = tabsContainer.firstChild;

      // Insert tabs before the first block in region content
      var firstBlock = regionContent.querySelector(
        ".block-views-blocknews-events-block-1, .block-views-blockevents-block-1",
      );
      if (firstBlock) {
        // Find the main page block first
        var pageBlock = regionContent.querySelector(".block-system-main-block");
        if (pageBlock && pageBlock.nextSibling) {
          regionContent.insertBefore(tabsElement, pageBlock.nextSibling);
        } else {
          regionContent.insertBefore(tabsElement, firstBlock);
        }
      }

      // Set initial state - news active
      regionContent.setAttribute("data-mobile-tabs", "true");
      newsBlock.classList.add("is-tab-active");

      // Tab click handlers
      var tabs = tabsElement.querySelectorAll(".events-mobile-tab");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var targetTab = this.getAttribute("data-tab");

          // Update tab active states
          tabs.forEach(function (t) {
            t.classList.remove("is-active");
          });
          this.classList.add("is-active");

          // Update block visibility
          if (targetTab === "news") {
            newsBlock.classList.add("is-tab-active");
            eventsBlock.classList.remove("is-tab-active");
          } else {
            newsBlock.classList.remove("is-tab-active");
            eventsBlock.classList.add("is-tab-active");
          }
        });
      });

      // Handle window resize - reset state if going above tablet breakpoint
      var tabBreakpoint = 768;
      var wasAboveBreakpoint = window.innerWidth > tabBreakpoint;

      window.addEventListener("resize", function () {
        var isAboveBreakpoint = window.innerWidth > tabBreakpoint;

        // Transitioning from mobile to desktop
        if (!wasAboveBreakpoint && isAboveBreakpoint) {
          // Show both blocks
          newsBlock.classList.remove("is-tab-active");
          eventsBlock.classList.remove("is-tab-active");
          regionContent.removeAttribute("data-mobile-tabs");
        }

        // Transitioning from desktop to mobile
        if (wasAboveBreakpoint && !isAboveBreakpoint) {
          // Re-enable tabs
          regionContent.setAttribute("data-mobile-tabs", "true");
          // Reset to news tab
          tabs.forEach(function (t) {
            t.classList.remove("is-active");
          });
          tabs[0].classList.add("is-active");
          newsBlock.classList.add("is-tab-active");
          eventsBlock.classList.remove("is-tab-active");
        }

        wasAboveBreakpoint = isAboveBreakpoint;
      });

      // Initial check - if already on mobile, ensure correct state
      if (window.innerWidth <= tabBreakpoint) {
        regionContent.setAttribute("data-mobile-tabs", "true");
        newsBlock.classList.add("is-tab-active");
      } else {
        regionContent.removeAttribute("data-mobile-tabs");
        newsBlock.classList.remove("is-tab-active");
        eventsBlock.classList.remove("is-tab-active");
      }
    },
  };

  /* 
  | ============================================================================
  | NEWS EVENTS SECTION - Scroll Animation
  | Migrated from React NewsEventsSection.tsx (music-school-reimagined)
  | Fade-up animation on scroll with staggered card animations
  | ============================================================================
  */

  Drupal.behaviors.newsEventsSection = {
    attach: function (context, settings) {
      var sections = context.querySelectorAll
        ? context.querySelectorAll(
            ".news-events-section, [data-animate='fade-up']",
          )
        : [];

      sections.forEach(function (section) {
        if (section.hasAttribute("data-news-events-attached")) return;
        section.setAttribute("data-news-events-attached", "true");

        // Get all cards in this section for staggered animation
        var cards = section.querySelectorAll(".news-card");

        // Set initial state for cards (staggered)
        cards.forEach(function (card, index) {
          card.style.transitionDelay = index * 0.1 + "s";
        });

        // IntersectionObserver for scroll-triggered animation
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                // Add animated class to trigger CSS transitions
                entry.target.classList.add("is-visible");
                entry.target.classList.add("animated");
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.15,
            rootMargin: "0px 0px -50px 0px",
          },
        );

        observer.observe(section);
      });
    },
  };

  /* 
  | ============================================================================
  | CAMP SCHEDULE - Accordion System
  | Migrated from React CampDetail.tsx Schedule section
  | ============================================================================
  */

  Drupal.behaviors.scheduleAccordion = {
    attach: function (context, settings) {
      // Initialize individual accordion triggers
      var triggers = context.querySelectorAll
        ? context.querySelectorAll(".schedule-day__trigger")
        : [];

      triggers.forEach(function (trigger) {
        if (trigger.hasAttribute("data-accordion-attached")) return;
        trigger.setAttribute("data-accordion-attached", "true");

        trigger.addEventListener("click", function () {
          var accordion = this.closest(".schedule-day__accordion");
          if (!accordion) return;

          var isOpen = accordion.dataset.state === "open";
          accordion.dataset.state = isOpen ? "closed" : "open";
          this.setAttribute("aria-expanded", !isOpen);
        });
      });

      // Initialize "Expand All / Collapse All" toggle buttons
      var toggleBtns = context.querySelectorAll
        ? context.querySelectorAll(".schedule-section__toggle-all")
        : [];

      toggleBtns.forEach(function (btn) {
        if (btn.hasAttribute("data-toggle-attached")) return;
        btn.setAttribute("data-toggle-attached", "true");

        btn.addEventListener("click", function () {
          var section = this.closest(".schedule-section");
          if (!section) return;

          var accordions = section.querySelectorAll(".schedule-day__accordion");
          var allOpen = Array.prototype.every.call(accordions, function (a) {
            return a.dataset.state === "open";
          });

          accordions.forEach(function (accordion) {
            accordion.dataset.state = allOpen ? "closed" : "open";
            var accordionTrigger = accordion.querySelector(
              ".schedule-day__trigger",
            );
            if (accordionTrigger) {
              accordionTrigger.setAttribute("aria-expanded", !allOpen);
            }
          });

          this.textContent = allOpen
            ? Drupal.t("Expand All")
            : Drupal.t("Collapse All");
        });
      });
    },
  };

  /* 
  | ============================================================================
  | INSTAGRAM FEED WIDGET - Scroll Animation
  | Migrated from React InstagramFeed.tsx (music-school-reimagined)
  | Fade-up animation on scroll
  | ============================================================================
  */

  Drupal.behaviors.instagramFeedWidget = {
    attach: function (context, settings) {
      var widgets = context.querySelectorAll
        ? context.querySelectorAll(
            "#block-rkpt-elfsightwidget, .paragraph--type--widget",
          )
        : [];

      widgets.forEach(function (widget) {
        if (widget.hasAttribute("data-instagram-attached")) return;
        widget.setAttribute("data-instagram-attached", "true");

        // IntersectionObserver for scroll-triggered animation
        if ("IntersectionObserver" in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  // Add animated class to trigger CSS transitions
                  entry.target.classList.add("is-visible");
                  entry.target.classList.add("animated");
                  observer.unobserve(entry.target);
                }
              });
            },
            {
              threshold: 0.15,
              rootMargin: "0px 0px -50px 0px",
            },
          );

          observer.observe(widget);
        } else {
          // Fallback if IntersectionObserver is not supported
          widget.classList.add("is-visible");
          widget.classList.add("animated");
        }
      });
    },
  };
  // Prevent Views AJAX from scrolling the page after filter updates.
  // Two-pronged: override the command AND save/restore scroll position,
  // because the command fires before behaviours re-attach.
  Drupal.behaviors.disableViewsScrollTop = {
    attach: function () {
      Drupal.AjaxCommands.prototype.viewsScrollTop = function () {};
    },
  };

  // ---------------------------------------------------------------------------
  // School map — Get Directions (opens Google Maps in new tab)
  // ---------------------------------------------------------------------------
  Drupal.behaviors.schoolMapDirections = {
    attach: function (context) {
      var btn = once(
        "school-map-directions",
        ".map-directions-btn",
        context,
      )[0];
      if (!btn) return;

      btn.addEventListener("click", function () {
        var fallbackUrl = btn.dataset.fallbackUrl;

        if (!navigator.geolocation) {
          window.open(fallbackUrl, "_blank");
          return;
        }

        navigator.geolocation.getCurrentPosition(
          function (position) {
            var origin =
              position.coords.latitude + "," + position.coords.longitude;
            var destMatch = fallbackUrl.match(
              /destination=([\d.\-]+),([\d.\-]+)/,
            );
            var dest = destMatch ? destMatch[1] + "," + destMatch[2] : "";
            var url =
              "https://www.google.com/maps/dir/?api=1&origin=" +
              origin +
              "&destination=" +
              dest +
              "&travelmode=driving";
            window.open(url, "_blank");
          },
          function () {
            window.open(fallbackUrl, "_blank");
          },
        );
      });
    },
  };

  var _viewsScrollSaved = null;
  $(document)
    .on("ajaxSend", function (_e, _jqXHR, settings) {
      if (settings.url && settings.url.indexOf("views/ajax") !== -1) {
        _viewsScrollSaved = $(window).scrollTop();
      }
    })
    .on("ajaxComplete", function (_e, _jqXHR, settings) {
      if (
        _viewsScrollSaved !== null &&
        settings.url &&
        settings.url.indexOf("views/ajax") !== -1
      ) {
        var pos = _viewsScrollSaved;
        _viewsScrollSaved = null;
        // setTimeout 0 runs after Drupal has processed all AJAX commands
        setTimeout(function () {
          $(window).scrollTop(pos);
        }, 0);
      }
    });
})(jQuery, Drupal, drupalSettings);
